module.exports = __webpack_public_path__ + "img/multidevice2.5eea4e63.png";